import { render, staticRenderFns } from "./OrderReportFood.vue?vue&type=template&id=d2b0f500&scoped=true"
import script from "./OrderReportFood.vue?vue&type=script&lang=js"
export * from "./OrderReportFood.vue?vue&type=script&lang=js"
import style0 from "./OrderReportFood.vue?vue&type=style&index=0&id=d2b0f500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b0f500",
  null
  
)

export default component.exports